export default "__VITE_ASSET__Bk8W40oE__"